// extracted by mini-css-extract-plugin
export default {"event-container":"event-container-977c","single":"single-2b23","celebrate-row":"celebrate-row-da27"};